import { render, staticRenderFns } from "./noticevisitors.vue?vue&type=template&id=7ec07e42&scoped=true&"
import script from "./noticevisitors.vue?vue&type=script&lang=js&"
export * from "./noticevisitors.vue?vue&type=script&lang=js&"
import style0 from "./noticevisitors.vue?vue&type=style&index=0&id=7ec07e42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec07e42",
  null
  
)

export default component.exports